import { Injectable, inject, PLATFORM_ID } from '@angular/core';
import { fromEvent, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { OnInit, OnDestroy } from '@angular/core';
import { HostListener } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class Utils implements OnInit, OnDestroy {

  private errorHorizontalImagePath: string = 'assets/images/not_found_3_2.png';
  private errorVerticalImagePath: string = 'assets/images/not_found_2_3.png';
  private resizeSubscription?: Subscription;

  windowWidth: number = 0;
  windowHeight: number = 0;
  content: string | null = null;
  private platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    if (!isPlatformBrowser(this.platformId)) return;

    this.windowWidth = window.innerWidth;
    this.windowHeight = window.innerHeight;

    this.resizeSubscription = fromEvent(window, 'resize')
      .pipe(debounceTime(200))
      .subscribe(() => {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
      });
  }

  ngOnDestroy(): void {
    this.resizeSubscription?.unsubscribe();
  }

  movieNameSplitter(sentence: string): string {

    return sentence
      .toLowerCase()
      .trim()
      .replace(/[:\-–]/g, '')         // remove colons & dashes
      .replace(/[^\w\s]/g, '')        // remove all punctuation except spaces
      .replace(/\s+/g, '-')           // replace spaces with single dash
  }

  filterSearchQuery(sentence: string): string {
    return sentence
      .toLowerCase()
      .trim()
      .replace(/[:\-–]/g, '')        // remove colons & dashes
      .replace(/[^\w\s]/g, '')       // remove punctuation
      .replace(/\s+/g, ' ');         // <-- keep single space, not '+'
  }

  onImageHorizontalError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.errorHorizontalImagePath;
    target.style.aspectRatio = '3/2'
  }

  onImageVerticalError(event: Event) {
    const target = event.target as HTMLImageElement;
    target.src = this.errorVerticalImagePath;
  }

  setLanguage(lang: string) {
    if (!isPlatformBrowser(this.platformId)) return;
    localStorage.setItem("preferredLanguage", lang);
    location.reload(); // reload site with new language
  }

  extractYearFromDate(date: string | null | undefined): number | null {

    if (!date) return null;
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed.getFullYear();
  }

  extractMonthFromDate(date: string | null | undefined): string | null {

    const months = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "Augest",
      "September",
      "October",
      "November",
      "December"
    ]

    if (!date) return null;
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : months[parsed.getMonth()];
  }

  extractDateFromDate(date: string | null | undefined): number | null {
    if (!date) return null;
    const parsed = new Date(date);
    return isNaN(parsed.getTime()) ? null : parsed.getDate();
  }

  filerRatings(ratings: number) {
    return Math.floor(ratings * 10)
  }

  kebabDropDown(isActive: boolean) {
    return !isActive
  }

  tripContent(content: string | null | undefined) {
    if (!content) return '';

    const viewportWidth = isPlatformBrowser(this.platformId)
      ? window.innerWidth
      : this.windowWidth || 1024;

    const limit = viewportWidth >= 768 ? 450 : viewportWidth >= 360 ? 200 : 50;

    if (content.length <= limit) {
      return content;
    }

    return `${content.slice(0, limit).trimEnd()}...`;
  }

  userProfileNameFilter(sentence: string): string | null {
    if (!sentence) return null;

    return sentence
      .trim()
      .replace(/[:\-–]/g, '')
      .replace(/[^\w\s]/g, '')
      .replace(/\s+/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
  }

  truncateTitle(title: string, limit: number = 24): string {
    if (!title) return '';
    return title.length > limit ? title.slice(0, limit) + '...' : title;
  }

}
